import {
  ChangeDetectorRef,
  Component,
  Injector,
  OnInit,
  ViewChild,
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { SecondPageIndexBase } from 'vnpost-shared';
import { CreateGroupServiceProductComponent } from './create-group-service-product/create-group-service-product.component';
import { EditGroupServiceProductComponent } from './edit-group-service-product/edit-group-service-product.component';
import { GroupServiceProductService } from '../services/group-service-product.service';
import { ImportGroupServiceProductComponent } from './import-group-service-product/import-group-service-product.component';

@Component({
  selector: 'app-group-service-product',
  templateUrl: './group-service-product.component.html',
  styleUrls: ['./group-service-product.component.css']
})
export class GroupServiceProductComponent extends SecondPageIndexBase implements OnInit {
  @ViewChild('pCreate', { static: false }) pCreate: CreateGroupServiceProductComponent;
  @ViewChild('pEdit', { static: false }) pEdit: EditGroupServiceProductComponent;
  @ViewChild('pImport', { static: false }) pImport: ImportGroupServiceProductComponent;
  code: any;
  setWidth: string = '100%';
  formGroup: UntypedFormGroup;
  constructor(
    private router: Router,
    private _service: GroupServiceProductService,
    private cd: ChangeDetectorRef,
    protected _injector: Injector
  ) {
    super(_service, _injector);
    this.formGroup = new UntypedFormGroup({
      code: new UntypedFormControl(''),
    });
    this.cols = [
      {
        field: 'stt',
        header: 'STT',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'businessSectorCode',
        header: 'Lĩnh vực kinh doanh',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'serviceProductGroupCode',
        header: 'Mã nhóm',
        visible: true,
        sort: false,
        width: 10,
      },
      {
        field: 'serviceProductGroupName',
        header: 'Tên nhóm sản phẩm dịch vụ',
        visible: true,
        sort: false,
        width: 10,
      },
      {
        field: 'status',
        header: 'Trạng thái áp dụng',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'action',
        header: 'Hành động',
        visible: true,
        sort: false,
        width: 15,
      },
    ];
  }
  ngOnInit(): void {
    this.getData();
  }

  search() {
    this.pageIndex = 1;
    this.pageSize = 20;
    this.totalRecord = 0;
    this.getData();
  }

  getData() {
    this.isLoading = true;
    this.code = this.code ? this.code.trim() : '';
    var model = {
      code: this.code ?? '',
      pageNo: this.pageIndex - 1,
      pageSize: this.pageSize
    };
    var index= model.pageNo*model.pageSize
    this._service
      .getListServiceProduct(model)
      .then((res) => {
        if (res) {
          
          this.dataSource = res.data;
          if(this.dataSource){
            this.dataSource.forEach(e => {
              index++
              e.stt=index
            });
          }
          this.totalRecord = res.total;
        }
      })
      .finally(() => (this.isLoading = false));
  }

  editServiceProduct(item: any, isDisable: boolean) {
    if (item && item.id)
      var model = {
        id: item.id,
        isDisable: isDisable,
      };
     this.pEdit.showPopup(model);
  }
  deleteServiceProduct(item: any) {
    if (item && item.id && item.status) {
      this._notifierService
        .showConfirm('Bạn có chắc muốn ngừng hoạt động nhóm dịch vụ sản phẩm này')
        .then((res) => {
          if (res) {
            // this._service.delete(item.identifier).then(
            //   () => {
            //     this._notifierService.showDeleteDataSuccess();
            //     this.getData();
            //   },
            //   () => {
            //     this._notifierService.showDeleteDataError();
            //   }
            // );
            this._service.inactive(item.id).then(
              (response) => {
                this._notifierService.showUpdateDataSuccess();
                this.getData();
              },
              (error) => {
                this._notifierService.showUpdateDataFailed();
              }
            );
          }
        });
    }
  }
  onAdd() {
     this.pCreate.showPopup();
  }
  onImport() {
    this.pImport.showPopup();
  }

  onSelectedVisible() {
    var dataWidth = 0;
    this.cols.forEach((e) => {
      if (e.visible == true) {
        dataWidth += e.width;
      }
    });
    this.setWidth = dataWidth + 'rem';
  }
}
